var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.filters, _vm.classDevice(_vm.$style)]},_vm._l((_vm.items),function(item,index){return _c('nuxt-link',{key:index,class:_vm.$style.link,attrs:{"to":item.url}},[_vm._v("\n    "+_vm._s(item.title)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }